import * as PropTypes from "prop-types";
import styled from "styled-components";
import TextField from "basicComponents/TextField/TextField";

export default function SearchTextField(props) {
  return (
    <TextFieldWrapper
      showTableContent={props.showTableContent}
      removeBorder={props.removeBorder}
    >
      <TextField
        id={props.id}
        focusTextField={props.focusTextField}
        keepPlaceholder={props.keepPlaceholder}
        removeBorder={props.removeBorder}
        width={props.width}
        onChange={props.onChange}
        searchIcon={props.searchIcon}
        placeholder={props.placeholder}
        value={props.value}
        items={props.items}
      />
    </TextFieldWrapper>
  );
}

SearchTextField.propTypes = {
  showTableContent: PropTypes.bool,
  removeBorder: PropTypes.bool,
  focusTextField: PropTypes.bool,
  keepPlaceholder: PropTypes.bool,
  width: PropTypes.number,
  onChange: PropTypes.func,
  searchIcon: PropTypes.bool,
  placeholder: PropTypes.any,
  value: PropTypes.any,
  items: PropTypes.array,
  id: PropTypes.string,
};

const TextFieldWrapper = styled.div`
  border: 1px solid black;

  ${({ removeBorder }) => (removeBorder ? "border 0px !important" : "")};

  ${({ showTableContent }) => (showTableContent ? "" : "border: unset")};

  border-radius: 10px;
  margin-top: -1px;
  margin-right: -1px;
  margin-left: -1px;
`;
